import React, { memo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import IconButton from '@lib/components/IconButton/IconButton';
import { BaseItem, Column } from '@lib/components/Table/types';
import CellContent from '../CellContent';
import styles from './CellWithActions..module.scss';

interface CellWithActionsProps<T extends BaseItem> {
  column: Column<T>;
  item: T;
}

function CellWithActions<T extends BaseItem>({
  column,
  item,
}: CellWithActionsProps<T>) {
  return (
    <div className={styles.root}>
      <CellContent column={column} item={item} />
      <div className={styles.actions}>
        {(column.actions || []).map((action) => (
          <IconButton
            key={action?.id || uuidv4()}
            {...action}
            onClick={() => action.onClick(item)}
            data-test-id={
              action?.id ? `table__cell-action-${action.id}` : undefined
            }
          />
        ))}
      </div>
    </div>
  );
}

export default memo(CellWithActions) as <T extends BaseItem>(
  props: CellWithActionsProps<T>,
) => React.ReactElement;
